import { Redirect } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { isLocal } from '../constants/envs';
import { isPriviledgedUser } from './authUtils';
import { useImxAuth } from '../hooks/useImxAuth';


const ProtectedRoute = ({ component: Component, ...rest }) => {
    const UserState = useSelector((store) => store.user);
    const InventoryState = useSelector((store) => store.inventory);
    const { csAssets: waxAssets = {}, hive = {}, skale = {}, eth = {}, imx = {} } = InventoryState;
    const { nfts: hiveNfts = [], username: hiveUsername } = hive;
    const { nfts: ethNfts = [], username: ethUsername } = eth;
    const { nfts: sklNfts = [], username: skaleUsername } = skale;
    const { nfts: imxNfts = [], username: imxUsername } = imx;
    // NFTs counting
    const hasWaxNfts = (waxAssets?.csNfts.length + Object.keys(waxAssets?.hotNfts || {}).length) > 0;
    const hasHiveNfts = hiveNfts.length > 0;
    const hasEthNfts = ethNfts.length > 0;
    const hasSklNfts = sklNfts.length > 0;
    const hasImxNFTs = imxNfts.length > 0;
    const hasNfts = hasWaxNfts || hasHiveNfts || hasEthNfts || hasSklNfts || hasImxNFTs;
    // username
    const hasUsername = hiveUsername || skaleUsername || ethUsername || imxUsername;
    // Can be used: login, nfts, username
    const canBeFullyUsed = UserState.isLogged && (hasNfts || hasUsername);
    const canUseAdminPanel = (props) => get(props, 'location.pathname') === 'admin'
        && isPriviledgedUser(UserState.name);

    const { isAuthenticated, isLoading } = useImxAuth();
    console.log('[imx] status in routes:', { isLoading, isAuthenticated });

    return (
        <Route {...rest} render={
            (props) => {
                isLocal && console.debug('Rendering component for:',
                  {
                    locationObj: props.location,
                    user: UserState.name,
                    isAdmin: isPriviledgedUser(UserState.name),
                  }
                );
                if (canUseAdminPanel(props)) {
                    return <Component {...rest} {...props} />
                } if (canBeFullyUsed) {
                    return <Component {...rest} {...props} />
                } else {
                    isLocal && console.error('{cant be fully used}');
                    return <Redirect to={
                        {
                            pathname: '/',
                            state: {
                                from: props.location
                            }
                        }
                    } />
                }
            }
        } />
    )
}

export default ProtectedRoute;
